import { render, staticRenderFns } from "./CommodityDerivatives.vue?vue&type=template&id=7cb467f0&"
import script from "./CommodityDerivatives.vue?vue&type=script&lang=js&"
export * from "./CommodityDerivatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports